/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-07-27 19:21:22
 * @LastEditors: 张印 hbzyin@163.com
 * @LastEditTime: 2023-08-19 09:36:21
 * @FilePath: /mall-fe/src/comps/IconFont.tsx
 * @Description: iconfont转换React高阶组件
 *
 */
import React, { DetailedReactHTMLElement } from 'react';

const assembleClassName = (className: string) => {
  return {
    className: ['icon', 'iconfont', className].join(' '),
  };
};

type AssembleClassName = ReturnType<typeof assembleClassName>;

interface IconFontProps {
  className: string;
  [key: string]: any;
}
function IconFont(className: string): DetailedReactHTMLElement<AssembleClassName, HTMLSpanElement>;

function IconFont(
  props: IconFontProps,
): DetailedReactHTMLElement<AssembleClassName & typeof props, HTMLSpanElement>;
function IconFont(props: string | IconFontProps) {
  return React.createElement(
    'span',
    typeof props === 'object'
      ? {
          ...props,
          ...assembleClassName(props.className),
        }
      : assembleClassName(props),
  );
}

export default IconFont;
